<template>
  <div>
    <!-- Toolbar -->
    <v-app-bar color="red" dark outlined app>
      <v-btn icon @click="$router.go(-1)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>Pengaturan Toko</v-toolbar-title>
    </v-app-bar>
    <v-main>
      <v-list flat>
        <v-list-item
          @click="$router.push({ name: 'Menu', params: { id: storeId } })"
        >
          <v-list-item-content>
            <v-list-item-title>Ubah Menu</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item
          @click="$router.push({ name: 'Staff', params: { id: storeId } })"
        >
          <v-list-item-content>
            <v-list-item-title>Staff</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item
          @click="$router.push({ name: 'Report', params: { id: storeId } })"
        >
          <v-list-item-content>
            <v-list-item-title>Laporan</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <!--      <v-list-item @click="$router.push({name: 'bookkeeping_transaction_list'})">-->
        <!--        <v-list-item-content>-->
        <!--          <v-list-item-title>Pencatatan</v-list-item-title>-->
        <!--        </v-list-item-content>-->
        <!--      </v-list-item>-->
        <!--      <v-divider></v-divider>-->
      </v-list>
    </v-main>
  </div>
</template>

<script>
export default {
  name: "Store",
  data() {
    return {
      storeId: this.$route.params.id,
    };
  },
};
</script>